<template>
  <div>
    <div class="d-flex justify-content-center align-items-center w-100 h-100 font-large-2">
      Katakana letters
    </div>


    <div class="row">
      <router-link class="col-md-2" :to="{name: 'letter.id', params: {id: letter.id}}" :key="letter.key" v-for="letter in letters">
        <div>
          <img :src="`${backEndUrl}${letter.image}`" alt="">
          <div>
            {{letter.title}}
          </div>
          <div>
            {{letter.translation}}
          </div>
        </div>
      </router-link>
    </div>




  </div>
</template>

<script>
import {backEndUrl} from '@/helpers/consts';
import letters from "@/api/letters";

export default {
  name: "index",
  data() {
    return {
      letters: [],
      backEndUrl,
    }
  },
  created() {
    letters.getKatakana()
        .then(res => {
          this.letters = res.data
        })
        .catch(err => {
          console.log(err)
        })
  }
}
</script>

<style scoped>

</style>
